// extracted by mini-css-extract-plugin
export default {"addPill":"AddItemMenu_addPill__7tPIz","dropdown":"AddItemMenu_dropdown__aC5+j","item":"AddItemMenu_item__BgrwA"};